/**
 * La oferta de instalacion, atrapada antes de que React exista.
 *
 * Chrome, Edge y familia avisan que la app se puede instalar con
 * `beforeinstallprompt` UNA sola vez por carga, y suelen hacerlo apenas termina
 * de bajar la pagina: antes de que el modulo de la app corra. Un oyente puesto
 * desde un componente llega tarde y la oferta se pierde sin decir nada —le paso
 * a Xokoyotl con su primer instalador, que por eso nunca se uso—.
 *
 * Asi que se atrapa con un guion en linea del `<head>`, igual que la marca de
 * `data-standalone`: lo inyecta `vite.config.ts` (`installCapture`) a partir de
 * ESTA funcion, se guarda en `window.__abarrotesInstallOffer` y se avisa con un
 * evento; de ahi lo lee `lib/install.ts`. `preventDefault()` calla la barrita
 * propia de Chrome en Android: la oferta la hace la app, con su hoja.
 *
 * AUTOCONTENIDA A PROPOSITO: se serializa con `toString()` y corre donde no
 * existe nada de este modulo. Por eso no usa nada de afuera, y la prueba la
 * ejecuta igual que el navegador, a partir del texto (`install-capture.test.ts`).
 */

/** El evento con el que la app se entera de que la oferta cambio. */
export const INSTALL_EVENT = 'abarrotes:install';

export function captureInstallOffer(eventName: string): void {
  const w = window as Window & {
    __abarrotesInstallOffer?: Event | null;
    __abarrotesInstalled?: boolean;
  };
  w.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    w.__abarrotesInstallOffer = e;
    w.dispatchEvent(new Event(eventName));
  });
  w.addEventListener('appinstalled', () => {
    w.__abarrotesInstallOffer = null;
    w.__abarrotesInstalled = true;
    w.dispatchEvent(new Event(eventName));
  });
}

/** El guion tal como va en el `<head>`. */
export const INSTALL_CAPTURE_SCRIPT = `(${captureInstallOffer.toString()})(${JSON.stringify(INSTALL_EVENT)})`;
